import { Chip } from "@mui/material";
import {
	AutocompleteInput,
	BooleanField,
	BooleanInput,
	CreateButton,
	Datagrid,
	DateField,
	DeleteButton,
	EditButton,
	ExportButton,
	FilterButton,
	List,
	NumberField,
	ReferenceInput,
	ShowButton,
	TextField,
	TextInput,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { SoftDeleteToggle } from "@/components/SoftDeleteToggle";

const referralLinkFilters = [
	<TextInput key="code" label="Code" source="code" alwaysOn />,
	<ReferenceInput key="appId" source="appId" reference="apps">
		<AutocompleteInput
			optionText="name"
			label="App"
			filterToQuery={(q) => ({ name: q })}
		/>
	</ReferenceInput>,
	<ReferenceInput key="partnerId" source="partnerId" reference="partners">
		<AutocompleteInput
			optionText="name"
			label="Partner"
			filterToQuery={(q) => ({ name: q })}
		/>
	</ReferenceInput>,
	<BooleanInput key="active" label="Active" source="active" />,
];

const ListActions = () => (
	<TopToolbar>
		<FilterButton />
		<CreateButton />
		<ExportButton />
		<SoftDeleteToggle />
	</TopToolbar>
);

const DeletedChip = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;
	return <Chip label="Deleted" size="small" color="error" />;
};

const ApprovalStatusChip = () => {
	const record = useRecordContext();
	if (record?.deletedAt) return null;
	if (record?.partnerAgreedAt) {
		return <Chip label="Approved" size="small" color="success" />;
	}
	return <Chip label="Pending" size="small" color="warning" />;
};

export const ReferralLinkList = () => (
	<List
		filters={referralLinkFilters}
		actions={<ListActions />}
		sort={{ field: "createdAt", order: "DESC" }}
	>
		<Datagrid rowClick="show">
			<TextField source="code" />
			<TextField source="appName" label="App" />
			<TextField source="partnerName" label="Partner" />
			<NumberField source="commissionPercent" label="Commission %" />
			<NumberField source="attributionWindowDays" label="Window (days)" />
			<BooleanField source="active" />
			<ApprovalStatusChip />
			<DateField source="createdAt" label="Created" />
			<DeletedChip />
			<EditButton />
			<ShowButton />
			<DeleteButton />
		</Datagrid>
	</List>
);
